import React, { forwardRef } from "react";
import { Flex, Tooltip } from "@chakra-ui/react";
import { Button } from "components/RFQ/Button";
import { cn } from "utils/helpers";

const deadlineTooltip =
	"Submission deadline has passed. You can no longer accept or decline the invitation.";

const MenuBarComp = forwardRef(
	({ setShowDialog, tooltipProps, hasDeadlinePassed, ...props }, ref) => {
		return (
			<>
				<Flex
					gap={4}
					{...props}
				>
					<Tooltip
						{...tooltipProps}
						label={hasDeadlinePassed ? deadlineTooltip : "Accept Invitation"}
					>
						<Button
							btntype="primary"
							onClick={() => setShowDialog("accept")}
							data-testid="accept-button"
							disabled={hasDeadlinePassed}
						>
							<div className="font-roboto font-semibold text-white">
								Accept Invitation
							</div>
						</Button>
					</Tooltip>
					<Tooltip
						{...tooltipProps}
						label={hasDeadlinePassed ? deadlineTooltip : "Decline Invitation"}
					>
						<Button
							btntype="secondary"
							onClick={() => setShowDialog("decline")}
							data-testid="decline-button"
							disabled={hasDeadlinePassed}
						>
							<div
								className={cn(
									"font-roboto font-semibold",
									!hasDeadlinePassed && "text-utility-blue-dark-100"
								)}
							>
								Decline Invitation
							</div>
						</Button>
					</Tooltip>
				</Flex>
			</>
		);
	}
);

export default MenuBarComp;
